import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { EventData } from '../../providers/event';
@Component({
  selector: 'page-event-question-view',
  templateUrl: 'event-question-view.html',
})
export class EventQuestionView {

  obs: any;
  dataQuestions: any;
  client: any;
  event: any;
  diarySelected = 0;

  constructor(public navCtrl: NavController, public params: NavParams, public eventProvider: EventData) {
    this.client = this.params.get('client');
    this.event = this.params.get('event');

    this.obs = this.eventProvider.getQuestionsPublish(this.client, this.event.id).subscribe((result: any) => {
      this.dataQuestions = result;
    });
  }

  getItems(object) {
    let data = Object.keys(object).map(function (key) { return object[key]; });
    return data;
  }

  closeListener() {
    if (this.obs) {
      console.log('Se eliminan los observables de proyector de preguntas');
      this.obs.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-question-view/event-question-view.ts